import { lazy } from "react";
import { FC, useState } from "react";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { useFormik } from "formik";

import { Button, Grid } from "@mui/material";

import { getValidationSchema } from "../../../../shared/validations/schema";

const FormContainer = lazy(() => import("../../../../shared/components/formContainer").then((module) => ({ default: module.FormContainer })));
const InputTextfield = lazy(() => import("../../../../shared/components/textField"));
const ZoneList = lazy(() => import("../zoneList/zoneLists"));
const Drag = lazy(() => import("../reorderZones"));

const RouteCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/route-management/routes"
  );
  const [openZoneList, setOpenZoneList] = useState(false);
  const [showReorder, setShowReorder] = useState(false);
  const [selectedZones, setSelectedZones] = useState<any[]>([]);

  const handleClickOpenZoneList = () => {
    setOpenZoneList(true);
    setShowReorder(false);
  };

  const routeForm = useFormik({
    initialValues: {
      name: "",
      zoneIDs: null,
    },
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: getValidationSchema(["name"]),
    onSubmit: async (formData: any) => {
      const ids = selectedZones?.map((zone) => zone.id);
      formData.zoneIDs = ids;
      modifyData(`/admin/route`, "post", formData, routeForm);
    },
  });

  const titleBar = {
    title: "Create New Route",
    buttonTitle: "Create",
    headerTitle: "Routes",
    onClick: () => routeForm.handleSubmit(),
    dirty: routeForm.dirty,
    disabled: Object.keys(routeForm.errors)?.length !== 0 || selectedZones.length === 0,
    // editPermission ||
    buttonLoading: apiLoading,
  };
  return (
    <>
      <FormContainer titleBar={titleBar} loading={apiLoading}>
        <div style={{ margin: "20px 10px" }}>
          <Grid container alignItems="stretch" columnSpacing={2}>
            <Grid item md={4} sm={6} xs={6}>
              <InputTextfield
                form={routeForm}
                fieldProps={{
                  id: "route-name",
                  name: "name",
                  label: "Name",
                  placeholder: "Enter Name",
                  type: "text",
                  required: true,
                  capitalizedFirst: true,
                  autoFocus: true,
                }}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={6}>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2.5 }}
                onClick={handleClickOpenZoneList}
              >
                Select Zones
              </Button>{" "}
            </Grid>
          </Grid>
        </div>
        {openZoneList ? (
          <ZoneList
            openZoneList={openZoneList}
            setOpenZoneList={setOpenZoneList}
            selectedZones={selectedZones}
            setSelectedZones={setSelectedZones}
            setShowReorder={setShowReorder}
          ></ZoneList>
        ) : null}
        {showReorder ? (
          <Drag
            selectedZones={selectedZones}
            setSelectedZones={setSelectedZones}
            routeName={routeForm.values.name}
          />
        ) : null}
      </FormContainer>
    </>
  );
};
export default RouteCreate;
